module.exports = __webpack_public_path__ + "static/media/voxeet_reaching_out.0689dd2d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/sounds/voxeet_reaching_out.mp3
// module id = 510
// module chunks = 0